module.exports = "../../app/cells/components/contextual_nudge_card_cell.rb";